export const dataSidebar = [
    {
        id: 1,
        title: "Галерея",
        path: "/admin/gallery",
        icon: "customize"
    },
    {
        id: 2,
        title: "Номера в нашем отеле",
        path: "/admin/hotelabout",
        icon: "user"
    },
    {
        id: 3,
        title: "Отзывы посетителей",
        path: "/admin/number",
        icon: "pie-chart-alt-2"
    },
    {
        id: 4,
        title: "Новости",
        path: "/admin/news ",
        icon: "money-withdraw"
    },
    {
        id: 5,
        title: "Бронирование номеров",
        path: "/admin/contacts",
        icon: "bar-chart-alt-2"
    },
    {
        id: 6,
        title: "Контакти",
        path: "/admin/contact",
        icon: "bar-chart-alt-2"
    },
    {
        id: 7,
        title: "Добавить Админ",
        path: "/admin/addadmin",
        icon: "bar-chart-alt-2"
    },
]